// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__2C0iS","load1":"Spinner_load1__3CPR6"};